import { DatePicker, DayOfWeek, IconButton, Stack } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import Scriba from 'react-scriba';

export class EUIDatePicker extends Component {

    static defaultProps = {
        allowTextInput: true,
        disabled: false,
        isRequired: false,
        label: "",
        minDate: undefined,
        maxDate: undefined,
        onClear: undefined, // Si renseignée alors ajoute un bouton de remise à zéro à droite du champs
        onSelectDate: (date) => null,
        placeholder: "",
        title: "",
        value: "",
    };

    componentDidMount = () => {
        if (this.props.required)
            throw "Attention, sur les DatePickers la prop required n'existe pas ; utilisez isRequired";
    };

    render = () => {

        const { disabled, isRequired, minDate, maxDate, onClear, value } = this.props;

        const aujourdhui = new Date(Date.now());
        let initialPickerDate = undefined;
        if (!!minDate && minDate instanceof Date && minDate > aujourdhui) initialPickerDate = minDate;
        else if (!!maxDate && maxDate instanceof Date && maxDate < aujourdhui) initialPickerDate = maxDate;
        else initialPickerDate = aujourdhui;

        const datepicker = <DatePicker
            {...this.props}
            ariaLabel={isRequired && "Ce champ est obligatoire."}
            firstDayOfWeek={DayOfWeek.Monday}
            formatDate={date => Scriba.date().stringDateFormatCourt(date)}
            initialPickerDate={initialPickerDate}
            parseDateFromString={dateStr => Scriba.date().dateExtraireChaineDateCourte(dateStr)}
            strings={Scriba.officeUI().datePicker().DayPickerStrings()}
            textField={{ errorMessage: "" }}
            value={Scriba.date().getDateFromChaineISO(value)}
        />;

        if (!!onClear && typeof onClear === "function")
            return <Stack horizontal>
                <Stack.Item grow>
                    {datepicker}
                </Stack.Item>
                <IconButton
                    ariaLabel="Effacer"
                    disabled={disabled}
                    iconProps={{ iconName: "Trash" }}
                    onClick={onClear}
                    title="Effacer"
                />
            </Stack>;
        else return datepicker;

    };
}